<template>
    <pendo-date-picker
        class="single-date"
        full-width
        is-required
        :append-to-body="false"
        :disabled="readOnly"
        :invalid="checkValidRule && !valid"
        :locale-code="$segmentFlag('localizationUI') ? $locale() : undefined"
        :value="date"
        @select-date="updateDate" />
</template>

<script>
import { PendoDatePicker } from '@pendo/components';
import moment, { DATE_FORMAT } from '@/utils/moment-wrapper';

export default {
    name: 'SingleDate',
    components: {
        PendoDatePicker,
    },
    props: {
        value: {
            type: null,
            default: null,
        },
        field: {
            type: String,
            default: 'value',
        },
        checkValidRule: {
            type: Boolean,
            default: false,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['input'],
    computed: {
        date () {
            return moment(this.value, { ignoreTimeZone: true }).toDate();
        },
        valid () {
            return moment(this.value, DATE_FORMAT.iso, true, { ignoreTimeZone: true }).isValid();
        },
    },
    created () {
        const value = this.valid ? this.date : moment(new Date(), { ignoreTimeZone: true }).format(DATE_FORMAT.iso);
        this.updateDate({ value });
    },
    methods: {
        updateDate (date) {
            const value = moment(date.value, { ignoreTimeZone: true }).format(DATE_FORMAT.iso);

            if (this.field === 'value') {
                this.$emit('input', {
                    field: ['value', 'first', 'last'],
                    value: { value, first: null, last: null },
                });

                return;
            }

            this.$emit('input', { field: this.field, value });
        },
    },
};
</script>
